<template>
    <div class="p-compare-reserve__claim-table">
        <p class="a-form-inputs">
            <control label="Include In Table">
                <select v-model="tableFilter">
                    <option value="all">All</option>
                    <option value="inside">Inside Set Limit</option>
                    <option value="outside">Outside Set Limit</option>
                    <option value="under">Under Set Limit</option>
                    <option value="over">Above Set Limit</option>
                </select>
            </control>
        </p>
        <p>
            Your results have been further filtered to <span class="u-bold">{{tableClaims.length}}</span>
            based on your percentile selection.
        </p>
        <div class="a-table--short-no-style">
            <table class="a-table a-table--full-width">
                <thead>
                <tr>
                    <th rowspan="2" valign="top"><h2>Claim Reference</h2></th>
                    <th rowspan="2" valign="top"><h2>{{fromLabel}}</h2></th>
                    <th rowspan="2" valign="top"><h2>{{toLabel}}</h2></th>
                    <th rowspan="2" valign="top"><h2>Claim Handler</h2></th>
                    <th colspan="2"><h2>Difference</h2></th>
                    <!--<th rowspan="2"></th>-->
                </tr>
                <tr>
                    <th><h2>&pound;</h2></th>
                    <th><h2>%</h2></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="claim in claims">
                    <td>{{claim.reference}}</td>
                    <td>{{currencyFormat(claim.from)}}</td>
                    <td>{{currencyFormat(claim.to)}}</td>
                    <td>{{claim.claimHandler}}</td>
                    <td>{{currencyFormat(Math.abs(claim.difference))}}</td>
                    <td>{{displayPercent(claim.percent)}}</td>
                    <!--<td width="20" @click="doLoad(claim)">-->
                    <!--<icon-tooltip :tooltip-name="'load' + claim.id" tooltip-text="load" side="left"-->
                    <!--text-width="100" icon-type="load"></icon-tooltip>-->
                    <!--</td>-->
                </tr>
                </tbody>
            </table>
        </div>
        <paginator :pageNumbers="pageNumbers" :pageNo="pageNo" @change="changePage"></paginator>
    </div>
</template>

<script>
    import currencyFormat from "mixins/currencyFormat";
    import roundValue from "mixins/roundValue";
    import {mapActions, mapGetters} from "vuex";
    import IconTooltip from 'components/IconTooltip'
    import Paginator from "components/Paginator";
    import Control from "../../../components/form/Control";

    const labels = {
        "dayOne": 'Day One',
        "paid": 'Paid',
        "final": 'Final Reserve',
        "initial": 'Initial Reserve',
    };

    export default {
        name: 'claim-table',
        mixins: [
            currencyFormat,
            roundValue
        ],
        components: {
            Control,
            Paginator,
            IconTooltip
        },
        data() {
            return {pageNo: 0, perPage: 10}
        },
        computed: {
            ...mapGetters('reserves/compare', ['tableClaims', 'from', 'to', 'totalClaims', 'includeInTable']),
            fromLabel() {
                return labels[this.from];
            },
            toLabel() {
                return labels[this.to];
            },
            claims() {
                return this.tableClaims.slice(this.pageNo * this.perPage, (this.pageNo + 1) * this.perPage);
            },
            pageNumbers() {
                return Math.ceil(this.tableClaims.length / this.perPage);
            },
            tableFilter: {
                get() {
                    return this.includeInTable;
                },
                set(value) {
                    this.update({key: 'includeInTable', value});
                }
            }
        },
        methods: {
            ...mapActions('claim', ['load']),
            ...mapActions('reserves/compare', ['update']),
            doLoad(claim) {
                this.load({claim, router: this.$router});
            },
            displayPercent(value) {
                if (value === Infinity) {
                    return "-";
                }
                return this.roundValue(value * 100, 2) + '%';
            },
            changePage(page) {
                this.pageNo = page;
            },
            percentDisplay(value) {
                if (!value) {
                    return "-";
                }
                return roundValue(value * 100, 2) + '%';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ClaimTable.vue?d197c8fe